import React from 'react';
import PropTypes from 'prop-types';
import { t } from 'i18next';
import {
  CategoryContainer,
  AccessorialsContentBox,
  AccessorialsContentBoxInfoRow,
  ContentBoxGap,
} from './css';
import CheckmarkIcon from '../../../../assets/icons/CheckMarkSolidOrange.svg';

const Accessorials = ({ formData }) => {
  const { accessorials } = formData;
  const selected = [];

  Object.keys(accessorials).forEach((idx) => {
    const obj = accessorials[idx];

    if (obj.selected) {
      selected.push(obj);
    }
  });

  return (
    <CategoryContainer>
      <AccessorialsContentBox>
        <ContentBoxGap>
          {selected.map((item, index) => (
            <AccessorialsContentBoxInfoRow key={index}>
              <img src={CheckmarkIcon} alt={t(item.title.value)} />
              {t(item.title.value)}
            </AccessorialsContentBoxInfoRow>
          ))}
        </ContentBoxGap>
      </AccessorialsContentBox>
    </CategoryContainer>
  );
};

Accessorials.propTypes = {
  formData: PropTypes.shape({
    accessorials: PropTypes.objectOf(
      PropTypes.shape({
        selected: PropTypes.bool,
        title: PropTypes.shape({
          value: PropTypes.string,
        }),
      }),
    ),
  }),
};

export default Accessorials;
